import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acl',
  templateUrl: './acl.component.html',
  styleUrls: ['./acl.component.scss']
})
export class AclComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
